/** Optional `device` field for starting: a SHA-256 of coarse browser traits (nothing readable). */
export async function deviceHint(): Promise<string | undefined> {
  try {
    const { sha256Hex } = await import('../../exam-guard');
    const parts = [
      navigator.userAgent,
      `${String(screen.width)}x${String(screen.height)}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.language,
    ];
    return await sha256Hex(parts.join('|'));
  } catch {
    return undefined;
  }
}
